import type {ReactElement} from 'react';
import React from 'react';
import styles from './information-box.module.scss';

interface InformationBoxProps {
  className?: string;
  type?: InformationBoxType;
  children: ReactElement<any>;
}

export enum InformationBoxType {
  NEUTRAL1 = 'NEUTRAL1',
  NEUTRAL3 = 'NEUTRAL3',
  PRIMARY = 'PRIMARY',
  WARNING = 'warning',
}

export function InformationBox({className = '', type = InformationBoxType.NEUTRAL3, ...props}: InformationBoxProps): ReactElement<any> | null {
  const getContainerClasses = (): string => {
    const classes = [styles.container, className, 'spacing-p-t-2 spacing-p-r-3 spacing-p-b-2 spacing-p-l-3 radius-4'];

    switch (type) {
      case InformationBoxType.PRIMARY:
        classes.push(styles.primary);
        break;
      case InformationBoxType.NEUTRAL1:
        classes.push(styles.neutral1);
        break;
      case InformationBoxType.NEUTRAL3:
        classes.push(styles.neutral3);
        break;
      case InformationBoxType.WARNING:
        classes.push(styles.warning);
        break;
      default:
        classes.push(styles.neutral);
    }

    return classes.join(' ');
  };

  return <div className={getContainerClasses()}>{props.children}</div>;
}
